import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from './ErrorBoundary';

type Props = {
  children: ReactNode;
  title?: string;
  spanPageContainerGrid?: boolean;
};

/**
 * Remounts the error boundary’s reset state when the route changes so
 * “Go back” (or any navigation) can recover the UI after an error.
 */
export function RouteResetErrorBoundary({
  children,
  title,
  spanPageContainerGrid,
}: Props): JSX.Element {
  const location = useLocation();
  const resetKey = `${location.pathname}${location.search}`;

  return (
    <ErrorBoundary resetKey={resetKey} spanPageContainerGrid={spanPageContainerGrid} title={title}>
      {children}
    </ErrorBoundary>
  );
}
